import { v4 as uuidv4 } from "uuid";
import { supabase } from "@/integrations/supabase/client";
import { Assessment } from "@/types/assessment";
import { getAssessmentById } from "./getAssessments";
import { saveCategoriesQuestionsAnswers } from "./saveCategoriesStructure";

// Create a new assessment
export const createAssessment = async (assessmentData: Partial<Assessment>): Promise<Assessment> => {
  try {
    const newAssessment = {
      id: uuidv4(),
      title: assessmentData.title || "Untitled Assessment",
      description: assessmentData.description || "",
      version: 0, // Start with version 0 for drafts
      is_active: assessmentData.isActive !== undefined ? assessmentData.isActive : true,
      is_maturity_model: assessmentData.isMaturityModel || false,
      slug: assessmentData.slug || `assessment-${Date.now()}`,
      status: "draft", // Always start as draft
      notify_emails: assessmentData.notifyEmails || null,
      calendly_link: assessmentData.calendlyLink || null,
      assessment_type: assessmentData.assessmentType || "statusObjective",
    };

    const { data: dbAssessment, error } = await supabase
      .from("assessments")
      .insert(newAssessment)
      .select()
      .single();

    if (error || !dbAssessment) {
      console.error("Error creating assessment:", error);
      throw error;
    }

    // If categories were provided, save them
    if (assessmentData.categories && assessmentData.categories.length > 0) {
      await saveCategoriesQuestionsAnswers(dbAssessment.id, assessmentData.categories);
    }

    return (await getAssessmentById(dbAssessment.id)) as Assessment;
  } catch (error) {
    console.error("Error in createAssessment:", error);
    throw error;
  }
};
